import { render, staticRenderFns } from "./RCA.vue?vue&type=template&id=1a48d62c&scoped=true"
import script from "./RCA.vue?vue&type=script&lang=js"
export * from "./RCA.vue?vue&type=script&lang=js"
import style0 from "./RCA.vue?vue&type=style&index=0&id=1a48d62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a48d62c",
  null
  
)

export default component.exports